const GeoPoint = {
  type: true,
  coordinates: true
};

export default GeoPoint;